module.exports = "/_next/static/resources/photo-4-0977878f3d3354086c1a922174b855cb.webp";